import * as React from "react";
import { SVGProps } from "react";
const SvgNotificationBell = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29.95 24.524v-1.2l-.737-.79-.34-.375c-2.48-2.77-3.44-4.705-4.323-11.235a9.823 9.823 0 0 0-1.306-3.695l-.194-.305c-1.1-1.8-2.9-3.1-5-3.6v-.2c0-1.1-.9-2-2-2s-2 .9-2 2v.2a8.038 8.038 0 0 0-4.838 3.347l-.162.253c-.8 1.2-1.3 2.6-1.5 4l-.118.845C6.46 18.453 5.32 20.058 2.15 23.324a.328.328 0 0 0-.1.24v.96c0 1.1.9 2 2 2h7c.4 2.7 2.9 4.7 5.6 4.3 2.2-.3 4-2.1 4.3-4.3h7c1.1 0 2-.9 2-2Zm-1.9 0h-24c.7-.8 1.4-1.7 2-2.7.1-.2.3-.5.4-.7 1.6-2.7 2.6-5.7 2.9-8.9 0-.6 0-1.2.126-1.8l.074-.3c.7-3 3.4-5.1 6.5-5 3.1-.1 5.8 2 6.4 5 .2.7.3 1.4.2 2.1.2 3.1 1.2 6.2 2.8 8.9l.6.9c.6.9 1.3 1.8 2 2.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotificationBell;
